import React from "react";
import { Box, Button, Divider, IconButton, MenuItem, OutlinedInput, Select, Stack, Tooltip } from "@mui/material";
import { Code, DarkMode, FiberNew, FormatBold, FormatClear, FormatItalic, FormatStrikethrough, FormatUnderlined, Highlight, Html, LightMode, Preview } from "@mui/icons-material";
import { styled } from '@mui/material/styles';
import Editor from '@monaco-editor/react';
import FontPopover from "./FontPopover";
import ImagemPopover from "./ImagemPopover";
import TemplatePopover from "./TemplatePopover";
import ModeloCodigoPopover from "./js/ModeloCodigoPopover";
import InpultEditorPopover from "./InpultEditorPopover";
import TextAlignmentPopover from "./TextAlignmentPopover";
import TextLinkPopover from "./TextLinkPopover";
import Service from "../../../util/Service";
import WidgetPopover from "./WidgetPopover";
import TableConfigBalloon from "./widget/TableConfigBalloon";
import TablePopover from "./TablePopover";
import LayoutPopover from "./LayoutPopover";
import FormCompPopover from "./FormCompPopover";

const IB = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
}));
const HEADER_ELEMENTS = ['H1', 'H2', 'H3', 'H4', 'H5', 'P', 'DIV', 'STRONG'];

const COR = "#FFF59D";
const COR_SELECTED = "lightblue";
var isResizing = false;
let startX = 0;
let startWidth = 0;
// export default function VeryEditor2(props){
const VeryEditor2 = React.forwardRef((props, ref) => {

    const { html, style, action, saveAction, staticOnly} = props;

    const refDiv = React.useRef();
    const [htmlCode, setHtmlCode] = React.useState(html);
    const [isHtmlCode, setIsHtmlCode] = React.useState(false);
    const [selectHeader, setSelectHeader] = React.useState('P');
    const [selectFont, setSelectFont] = React.useState('p');
    const [formatTextSelect, setFormatTextSelect] = React.useState();
    const [imgSelected, setImgSelected] = React.useState();
    const [themeEditor, setThemeEditor] = React.useState('vs-dark');
    const [textFieldSelected, setTextFieldSelected] = React.useState();
    const [selectItem, setSelectItem] = React.useState();
    const [selectText, setSelectText] = React.useState();
    const [templateSelected, setTemplateSelected] = React.useState();

    const editorRef = React.useRef(null);

    React.useEffect(() => {
        setHtmlCode(html);
    }, [html])

    React.useEffect(() => {
        if (htmlCode && !isHtmlCode) {
            if (!refDiv || !refDiv.current) return;
            refDiv.current.innerHTML = htmlCode;

            const allImages = refDiv.current.querySelectorAll('img');

            if (!allImages) return;
            for (let i = 0; i < allImages.length; i++) {
                const img = allImages[i];
                img.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    setSelectedElement(e.currentTarget);
                });
            }
            geraEventosSlideShow();
            geraEventoFigure();
            const root = document.documentElement;
            if (root) {
                console.log('>>>recalculando<<<')                
                root.style.setProperty('--pd-widget-outline-thickness', null);                
            }
        }
    }, [htmlCode, isHtmlCode]);

    function refreshEditor(tipo) {

        if (tipo === 'slideshow') {
            geraEventosSlideShow();
        }
        geraEventoFigure();
    }
    const removeEventListener = (figure) => {        
        for (const c of figure.childNodes) {

            if (c.tagName === 'DIV') {
                removeEventListener(c);
            } else if (c.tagName === 'BUTTON') {
                //c.removeAttribute('onclick');                
                c.classList.add("pd-disabled-element");
            }
        }
    }
    const geraEventoFigure = () => {
        const figures = refDiv.current.querySelectorAll("figure");
        for (let figure of figures) {
            //myElement.removeEventListener('click', handleClick);
            removeEventListener(figure);

            figure.setAttribute("class", "pd pd-widget_with-selection-handle");
            figure.setAttribute("contenteditable", true);

            let widget = figure.querySelector(".pd-widget__selection-handle")
            if (!widget) {
                console.error("pd-widget__selection-handle não encontrado");
                return;
            }
            widget.addEventListener('click', eventoClickFibure);
            
            figure.addEventListener("dragstart", handleDargStart);

            const table = figure.querySelector("table");

            if (table) {
                // table.addEventListener('click', toogleSelectCell );
                table.addEventListener('click', function (event) {
                    const els = document.querySelectorAll(".cell-selected");
                    for (let e of els) {
                        e.classList.toggle('cell-selected');
                    }
                    if (event.target.tagName === 'TD' || event.target.tagName === 'TH') {
                        const clickedCell = event.target;
                        clickedCell.classList.toggle('cell-selected');
                        let bal = document.querySelector(".pd-balloon-panel");
                        if (!bal) bal = document.querySelector(".pd-balloon-panel-up");
                        if (bal) {
                            bal.classList.remove('hidden');
                        }
                    }
                });
            }
            figure.addEventListener('mousedown', (e) => {
                figure.draggable = false;
                function doDrag(e) {
                    if (!isResizing) return;
                    //se for centralizado amplia ao dobro
                    const multiplicador = figure.parentNode.classList.contains("pd-widget") ? 2 : 1
                    let newWidth = startWidth + (((e.clientX) - startX) * multiplicador);
                    figure.style.width = newWidth + 'px';
                }
                function stopDrag() {
                    isResizing = false;
                    document.removeEventListener('mousemove', doDrag);
                    document.removeEventListener('mouseup', stopDrag);
                    figure.draggable = true;
                }
                isResizing = true;
                if (document.body.style.cursor === 'col-resize') {
                    console.log(">>resize<<")
                    isResizing = true;
                } else {
                    isResizing = false;
                    document.removeEventListener('mousemove', doDrag);
                    document.removeEventListener('mouseup', stopDrag);
                    figure.draggable = true;
                }
                startX = e.clientX;
                startWidth = figure.getBoundingClientRect().width;//offsetWidth;                        
                document.addEventListener('mousemove', doDrag);
                document.addEventListener('mouseup', stopDrag);
            })
            figure.addEventListener('mouseup', (event) => {
                isResizing = false;
            })
            figure.addEventListener('mouseleave', (event) => {
                if (isResizing) return;
                document.body.style.cursor = 'default';
            })
            figure.addEventListener('mouseover', (event) => {
                const root = document.documentElement;
                const rect = figure.getBoundingClientRect();
                if (root) {                    
                    let balloon = document.querySelector(".pd-balloon-panel");
                    if (!balloon) balloon = document.querySelector(".pd-balloon-panel-up");

                    const tool = document.getElementById("editor_tool");
                    const rectB = balloon.getBoundingClientRect();
                    const rectT = tool.getBoundingClientRect();
                    const h = - rect.height;
                    let posBalloon = rect.y
                    if ((rect.y - rectB.height) < rectT.y + rectT.height) {
                        posBalloon = rect.height + rect.y + rectB.height;
                        if (balloon.classList.contains('pd-balloon-panel')) {
                            balloon.classList.remove("pd-balloon-panel");
                            balloon.classList.add("pd-balloon-panel-up");
                        }
                    } else {
                        if (balloon.classList.contains('pd-balloon-panel-up')) {
                            balloon.classList.remove("pd-balloon-panel-up");
                            balloon.classList.add("pd-balloon-panel");
                        }
                    }

                    root.style.setProperty('--pc-widget-outline-thickness', `${h}px`);
                    root.style.setProperty('--pc-balloon-top', `${posBalloon}px`);
                }

                if (rect.x + rect.width - 8 < event.x && rect.x + rect.width + 10 > event.x) {
                    document.body.style.cursor = 'col-resize';
                } else {
                    document.body.style.cursor = 'default';
                }
                //event.target.style.backgroundColor = COR_SELECTED;
            });
            const elEnter = figure.querySelectorAll(".pd-widget__type-around__button");
            elEnter[0].addEventListener('click', (e) => handleAddNewLine(e, 'after'));
            elEnter[1].addEventListener('click', (e) => handleAddNewLine(e, 'before'));

        }
    }
    const handleAddNewLine = (e, origem) => {
        const figure = getElementFigure(e.target.parentNode)
        const p = document.createElement('div');
        // p.style="padding:1px;"
        p.innerHTML = "</br>";

        if (origem === "after") {
            figure.parentNode.parentNode.insertBefore(p, figure.parentNode);
        } else {
            figure.parentNode.parentNode.insertBefore(p, figure.parentNode.nextSibling);
        }
        setTimeout(() => {
            p.focus();
            const range = document.createRange();
            const selection = window.getSelection();
            range.setStart(p, 0); // Fallback to start of element
            range.setEnd(p, 0);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
        }, 300);

    }

    const getElementFigure = (comp) => {
        if (comp.tagName === 'FIGURE') {
            return comp;
        } else {
            if (comp.tagName === 'BODY') return;
            return getElementFigure(comp.parentNode);
        }
    }
    const handleDargStart = (e) => {
        // Add different types of drag data
        const conteudo = e.target.querySelector("[name='conteudo']");
        if (!conteudo) return;

        e.dataTransfer.setData("id", conteudo.id);
        // e.dataTransfer.setData("text/html", e.target.outerHTML);
        // e.dataTransfer.setData(
        //     "text/uri-list",
        //     e.target.ownerDocument.location.href,
        // );
    }
    const handleOnDrop = (e) => {
        e.preventDefault();
        if (isResizing) return;
        const id = e.dataTransfer.getData("id");
        if (!id) return;
        const el = refDiv.current.querySelector("#" + id);
        if (!el) {
            console.error("Elemento: " + id + " não encontrado.")
            return;
        }
        const figure = getElementFigure(el);
        if (e.target === figure.parentNode) {
            console.error("Cannot append an element to itself.");
            return;
        }
        e.target.append(figure.parentNode);

    }
    const handleDragOver = (e) => {
        console.log('>>>dragover<<<')
        e.preventDefault();
    }
    const eventoClickFibure = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const parent = getElementFigure(e.target);
        if (!parent) {
            console.error("não encontrado o FIGURE")
        }
        //const parent = e.target.parentNode.parentNode.parentNode.parentNode;
        setSelectedElement(parent);
        // const compname = parent.getAttribute("compname");
        const el = parent.querySelector(".pd-widget__selection-handle");
        const elEnter = parent.querySelectorAll(".pd-widget__type-around__button");

        if (!el) {
            console.error("Não existe pd-widget...")
        }

        // if (compname === "veryPageAPI") 
        {
            const root = document.documentElement;
            if (!el.style.visibility || el.style.visibility.length === 0) {
                if (root) root.style.setProperty('--pd-color-focus-border', COR_SELECTED);
                parent.style.border = "4px solid " + COR_SELECTED
                el.style.visibility = "visible";
                elEnter[0].style.visibility = "visible";
                elEnter[1].style.visibility = "visible";
            } else {
                parent.style.border = "";
                if (root) root.style.setProperty('--pd-color-focus-border', COR);
                el.style.visibility = "";
                elEnter[0].style.visibility = "";
                elEnter[1].style.visibility = "";
            }
        }
    }
    const geraEventosSlideShow = () => {
        const slide = refDiv.current.querySelector("[compname='verySlideshow']");

        if (!slide) return;

        slide.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            setSelectedElement(e.currentTarget);
        });

        slide.addEventListener('keydown', function (e) {
            // e.preventDefault();
            // e.stopPropagation();
            const keyName = e.key;

            if (keyName === 'Delete') {
                const dado = {
                    code: refDiv.current.innerHTML,
                    // qtdCampos: qtd
                }
                Service.POST("/api/security/model/deleteSlideShow", dado).then(r => {

                    if (r.success) {
                        refDiv.current.innerHTML = r.dado;
                    } else {
                        alert(r.msg)
                    }
                })
            }
            else if (keyName === 'Tab') {
                const el = document.createElement('div');
                //el.innerHTML = "NovaLinha";
                //el.tabIndex = -1;
                //el.contentEditable = "true";
                el.style.minHeight = "50px";
                el.style.border = "1px solid black";

                refDiv.current.appendChild(el);
                //el.focus();
            }
        });
        slide.classList.add('pd-element-select');

    }
    React.useImperativeHandle(ref, () => ({
        getHtml() {
            return handleComplete();
        }
    }));
    function handleComplete() {
        if (isHtmlCode) {
            return htmlCode;
        }
        return refDiv.current.innerHTML;
    }
    function handleScroll(e) {
        const figures = refDiv.current.querySelectorAll("figure");
        for (let figure of figures) {
            const root = document.documentElement;
            if (root) {
                let balloon = document.querySelector(".pd-balloon-panel");
                if (!balloon) balloon = document.querySelector(".pd-balloon-panel-up");
                if (!balloon) return;
                if (balloon.classList.contains("hidden")) return;

                const tool = document.getElementById("editor_tool");
                const rectB = balloon.getBoundingClientRect();
                const rectT = tool.getBoundingClientRect();
                let rect = figure.getBoundingClientRect();
                const h = rect.height;
                let posBalloon = rect.y

                if ((rect.y - rectB.height) < rectT.y + rectT.height) {
                    posBalloon = rect.height + rect.y + rectB.height;
                    if (balloon.classList.contains('pd-balloon-panel-up')) {
                        //se ja tem balloon up e passou então remove
                        if ((rect.y + rect.height) < rectT.y + rectT.height) {
                            balloon.classList.add('hidden');
                        }
                    }
                    if (balloon.classList.contains('pd-balloon-panel')) {
                        balloon.classList.remove("pd-balloon-panel");
                        balloon.classList.add("pd-balloon-panel-up");
                    }
                } else {
                    if (balloon.classList.contains('pd-balloon-panel-up')) {
                        balloon.classList.remove("pd-balloon-panel-up");
                        balloon.classList.add("pd-balloon-panel");
                    }
                }
                root.style.setProperty('--pd-widget-outline-thickness', `${-h}px`);
                root.style.setProperty('--pd-balloon-top', `${posBalloon}px`);
            }
        }
    }
    const novaPagina = () => {
        refDiv.current.innerHTML = "<div style='padding:2px'></div>";
        let bal = document.querySelector(".pd-balloon-panel");
        if (!bal) bal = document.querySelector(".pd-balloon-panel-up");
        if (bal) {
            bal.classList.add('hidden');
        }
    }
    function handleClick(e) {
        handleSelectionEvent();
        if (e.target.tagName !== 'TD' && e.target.tagName !== 'TH') {
            let bal = document.querySelector(".pd-balloon-panel");
            if (!bal) bal = document.querySelector(".pd-balloon-panel-up");
            if (bal) {
                bal.classList.add('hidden');
            }
            const els = document.querySelectorAll(".cell-selected");
            for (let e of els) {
                e.classList.toggle('cell-selected');
            }
        }
    }
    function setSelectedElement(el) {
        const root = document.documentElement;
        if (root) root.style.setProperty('--pd-color-focus-border', COR);
        handleSelectionEvent(el)

    }
    function handleSelectionEvent(element) {
        let el = element ? element : getParentElement();
        if (el) {
            setSelectFont(el.tagName);
            setSelectHeader(getParentRecursivo(el));
            setFormatTextSelect();
            setImgSelected();
            setTextFieldSelected();
            setTemplateSelected();
            if (el.tagName === 'SPAN') {
                const style = el.getAttribute('style');

                if (style) setFormatTextSelect(style)
            } else if (el.tagName === 'IMG') {
                setImgSelected(el);
            } else if (el.tagName === 'INPUT') {
                setTextFieldSelected(el);
            } else if (el.tagName === 'DIV' && el.getAttribute("compname") === "verySlideshow") {
                setTemplateSelected(el);
            }
        }
        const selecao = window.getSelection();
        const temTextoSelecionado = selecao.toString().trim().length > 0;
        if (temTextoSelecionado) {
            const range = selecao.getRangeAt(0);
            const containerComum = range.commonAncestorContainer;
            setSelectText(containerComum)
            const elementoAlinhamento = getElementoPaiParaAlinhamento(containerComum);
            setSelectItem(elementoAlinhamento)
        } else {
            if (element && element.nativeEvent) {
                const range = selecao.getRangeAt(0);
                el = range.startContainer;
            }
            if (precisaDeContainerPai(el)) {
                setSelectText(el)
                const elementoAlinhamento = getElementoPaiParaAlinhamento(el);
                setSelectItem(elementoAlinhamento);
            } else {
                setSelectItem(el);
            }
        }
    }
    function precisaDeContainerPai(elemento) {
        if (!elemento) return false;
        const elementosAlinhaveis = [
            'DIV', 'P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6',
            'SECTION', 'ARTICLE', 'HEADER', 'FOOTER', 'MAIN',
            'TD', 'TH', 'LI', 'BLOCKQUOTE'
        ];
        const elementosInline = [
            'SPAN', 'B', 'STRONG', 'I', 'EM', 'U', 'A', 'BUTTON',
            'INPUT', 'TEXTAREA', 'SELECT', 'LABEL', 'CODE'
        ];
        if (elementosAlinhaveis.includes(elemento.tagName)) {
            return false;
        }
        if (elementosInline.includes(elemento.tagName)) {
            return true;
        }
        return !elemento?.style?.textAlign;
    }
    function getElementoPaiParaAlinhamento(node) {
        if (node.nodeType === Node.TEXT_NODE) {
            return node.parentElement;
        }
        const elementosBloco = ['DIV', 'P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'SECTION', 'ARTICLE', 'LI', 'TD'];
        if (elementosBloco.includes(node.tagName)) {
            return node;
        }
        let elementoAtual = node;
        while (elementoAtual.parentElement) {
            elementoAtual = elementoAtual.parentElement;
            if (elementosBloco.includes(elementoAtual.tagName) || elementoAtual.tagName === 'BODY') {
                return elementoAtual;
            }
        }
        return node;
    }
    function getParentRecursivo(el) {
        if (!el) return '';
        const i = HEADER_ELEMENTS.find(h => h === el.tagName);
        if (i) return el.tagName;
        else return getParentRecursivo(el.parentElement);
    }
    function handleDbClick(e) {
        console.log('db');
        // setCurrent(e.target);
    }
    function handleItalic() {
        const novo = document.createElement('i');
        setSelectFont('I')
        setElemento(novo);
    }
    function handleBold() {
        const elP = getParentElement();

        if (elP.tagName === 'B') {
            removeElemento(elP)
        } else {
            const novo = document.createElement('b');
            setSelectFont('B')
            setElemento(novo);
        }
    }
    function handleUnderline() {
        const novo = document.createElement('u');
        setSelectFont('U');
        setElemento(novo);
    }
    function handleRiscado() {
        const novo = document.createElement('del');
        setSelectFont('DEL');
        setElemento(novo);
    }

    function getParentElement() {
        if (document.activeElement &&
            (document.activeElement.tagName === 'INPUT' ||
                document.activeElement.tagName === 'TEXTAREA' ||
                document.activeElement.tagName === 'SELECT')) {
            return document.activeElement;
        }
        const s = window.getSelection();
        if (s && s.rangeCount === 1) {
            const base = s.getRangeAt(0);//s.baseNode;
            const el = base.startContainer.parentElement;
            return el;
        }
        return null;
    }
    function removeElemento(el) {
        const span = document.createElement('span');
        span.textContent = el.textContent; // Copy the text content

        el.replaceWith(span);

        setSelectFont();

        const s = window.getSelection();
        const range = document.createRange();
        range.setStart(span, 0);
        range.setEnd(span, 1);

        s.removeAllRanges();
        s.addRange(range);

        span.focus();

    }
    function setElemento(novo, elRoot) {
        const s = window.getSelection();
        const parent = elRoot ? elRoot : getParentElement();
        if (parent.tagName === novo.tagName && parent.textContent === novo.textContent) {
            parent.replaceWith(novo);
            return;
        }
        // if (s && s.rangeCount === 1) 
        if (true) {
            const base = s.getRangeAt(0);//s.baseNode;
            const range = document.createRange();
            // if (base.endContainer.selectHeader === Node.TEXT_NODE) 
            if (s.isCollapsed || base.startContainer === base.endContainer) {
                const txt = window.getSelection().toString();
                // const el = base.parentElement;
                novo.textContent = txt;

                let tBase = base.endContainer.data;
                if (tBase == null) return;

                let init = tBase.substring(0, base.startOffset);
                let fim = tBase.substring(base.endOffset, tBase.length);

                const pai = base.endContainer.parentElement;

                if (init.trim().length > 0 || fim.trim().length > 0) {
                    const arr = pai.childNodes;
                    for (let x = 0; x < arr.length; x++) {
                        const item = arr[x];
                        if (item === base.endContainer) {
                            const spanP = document.createElement('span');
                            const spanInit = document.createElement('span');
                            const spanFim = document.createElement('span');
                            spanInit.textContent = init;
                            spanFim.textContent = fim;
                            spanP.appendChild(spanInit);
                            spanP.appendChild(novo);
                            spanP.appendChild(spanFim);
                            item.replaceWith(spanP);
                            break;
                        }
                    }
                } else {
                    const arr = pai.childNodes;
                    let ant = null;
                    for (let x = 0; x < arr.length; x++) {
                        const item = arr[x];
                        if (item.textContent.trim() === txt) {
                            //novo.textContent = item.textContent;
                            item.replaceWith(novo);
                            if (ant) ant.textContent = ant.textContent + " ";
                            if (x < arr.length) {
                                let proximo = arr[x + 1];
                                if (proximo) proximo.textContent = " " + proximo.textContent;
                            }
                            break;
                        }
                        ant = item;
                    }
                }
                if (novo.textContent.length === 0) {
                    novo.innerHTML = '&nbsp;';
                    range.setStart(novo, 0);
                    range.setEnd(novo, 1);
                } else {
                    range.setStart(novo, 1);
                }

            } else {
                console.error("selectHeader não implementado: " + base.endContainer.nodeType);
                const clonedContent = base.extractContents(); //.cloneContents();
                novo.appendChild(clonedContent);
                base.deleteContents(); // Removes the original content
                base.insertNode(novo); // Inserts the modified fragment
                range.setStart(novo, 0);
                range.setEnd(novo, 1);
            }
            setTimeout(() => {
                s.removeAllRanges();
                s.addRange(range);
                // refDiv.current.focus();
                novo.focus();
            }, 300);

        } else {
            alert('Não implementado...')
        }
    }

    function handleRemoveFormataTxt() {
        if (!selectText) return;
        const selecao = window.getSelection();
        if (selecao.rangeCount === 0) return;
        const range = selecao.getRangeAt(0);
        const textoLimpo = selecao.toString().trim();
        range.deleteContents();
        range.insertNode(document.createTextNode(textoLimpo));
    }
    function handleChangeNodeType(e) {


        const tipo = e.target.value

        const t = document.createElement(tipo);
        setElemento(t);

        // const base = s.baseNode;
        // if (base.nodeType === Node.TEXT_NODE) {
        //     const el = base.parentElement;
        //     t.textContent = base.textContent;
        //     el.replaceChild(t, base);
        // }
    }
    function handleKeyUp(e) {
        const c = e.code;
        
        if (c === 'ArrowDown' || c === 'ArrowLeft' || c === 'ArrowRight' || c === 'ArrowUp') {
            handleSelectionEvent(e);
        }
    }
    function addNewLine(e){
        const selection = window.getSelection();
        const range = selection.getRangeAt(0);
        const cc = range.startContainer;
        if( cc.id === "very2Editor"){ 
            return;
        }
        let pai = cc.parentNode;
        if( pai.id === "very2Editor"){ 
            return;
        }
        if( pai.tagName === 'DIV' && pai.parentNode.tagName === 'DIV') return;
        console.log(pai.tagName,  pai.parentNode.tagName)
        let el = document.createElement('br');
        
        e.preventDefault();
        if(e.shiftKey){
            pai.parentNode.appendChild(el);
        }else{
            if( pai.tagName === 'DIV'){
                const template = document.createElement('template');
                template.innerHTML = "<div style='padding:2px'><br></div>";
                el = template.content.firstElementChild;
                pai.parentNode.appendChild(el);
            }else
            range.insertNode(el);
        }
        range.setStartAfter(el);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
    }
    function handleKeyDown(e){
        if (e.key === 'Enter' || e.key === 'Enter') {
            addNewLine(e);
        } 
    }
    function handleEditorChange(value, event) {
        setHtmlCode(value);
    }
    function handleSwitchCode() {
        if (!isHtmlCode) {
            setHtmlCode(refDiv.current.innerHTML);
        } else {
            // console.log( htmlCode )
        }
        setIsHtmlCode(!isHtmlCode);
    }

    function handleEditorDidMount(editor, monaco) {
        editorRef.current = editor;
        editor.addCommand(
            monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyS, // Use CtrlCmd for cross-platform support (Cmd on Mac, Ctrl on Windows/Linux)
            function () {
                if(saveAction)saveAction();
                else console.error("SaveAction não informada!")
            },
            null
        );
    }
    const handleFormatDocument = () => {
        if (editorRef.current) {
            editorRef.current.trigger('editor', 'editor.action.formatDocument');
        }
    };
    const handleSwitchConstraste = () => {
        if (editorRef.current) {
            editorRef.current.trigger('editor', 'editor.action.toggleHighContrast');
        }
    }
    const handleSwitchDarkMode = () => {
        setThemeEditor(themeEditor === 'vs-dark' ? 'light' : 'vs-dark');
    }

    function HtmlEditor() {
        if (isHtmlCode) return;
        return (
            <React.Fragment>
                <Stack direction="row" spacing={0} id='editor_tool'>
                    <Select variant="outlined" sx={{ width: "70px", fontSize: '12px' }} size="small"
                        value={selectHeader}
                        onChange={handleChangeNodeType}
                        input={<OutlinedInput sx={{ fontSize: '12px' }} label="Tag" />} 
                    >
                        <MenuItem value={'DIV'}>DIV</MenuItem>
                        <MenuItem value={'P'}>P</MenuItem>
                        <MenuItem value={'H1'}>H1</MenuItem>
                        <MenuItem value={'H2'}>H2</MenuItem>
                        <MenuItem value={'H3'}>H3</MenuItem>
                        <MenuItem value={'H4'}>H4</MenuItem>
                        <MenuItem value={'STRONG'}>Destacado</MenuItem>
                    </Select>
                    {/* <Divider orientation="vertical" flexItem sx={{ml:1}} variant="middle"/> */}

                    <Tooltip title="Negrito">
                        <IB
                            // color={selectFont === 'B'?"primary":'inherit'}
                            sx={{
                                background: selectFont === 'B' ? 'lightgray' : 'transparent'
                            }}
                            variant='container'
                            onClick={handleBold}
                            size="small"
                        >
                            <FormatBold />
                        </IB>
                    </Tooltip>
                    <Tooltip title="Italico">
                        <IB
                            // color={selectFont === 'B'?"primary":'inherit'}
                            sx={{
                                background: selectFont === 'I' ? 'lightgray' : 'transparent'
                            }}
                            variant='container'
                            onClick={handleItalic}
                            size="small"
                        >
                            <FormatItalic />
                        </IB>
                    </Tooltip>
                    <Tooltip title="Sublinhado">
                        <IB
                            sx={{
                                background: selectFont === 'U' ? 'lightgray' : 'transparent'
                            }}
                            onClick={handleUnderline}
                            size="small"
                        >
                            <FormatUnderlined />
                        </IB>
                    </Tooltip>
                    <Tooltip title="Riscado">
                        <IB
                            sx={{
                                background: selectFont === 'DEL' ? 'lightgray' : 'transparent'
                            }}
                            onClick={handleRiscado}
                            size="small"
                        >
                            <FormatStrikethrough />
                        </IB>
                    </Tooltip>
                    <FontPopover
                        setElemento={setElemento}
                        // setSelection={setSelection}
                        format={formatTextSelect}

                    />
                    <Tooltip title="Remove Formato">
                        <IB
                            // color="primary" 
                            onClick={handleRemoveFormataTxt}
                            size="small"
                        >
                            <FormatClear />
                        </IB>
                    </Tooltip>
                    <Divider orientation="vertical" flexItem sx={{ ml: '0.5' }} variant="middle" />
                    <TextAlignmentPopover 
                        selectItem={selectItem} 
                    />

                    <Divider orientation="vertical" flexItem sx={{ ml: '0.5' }} variant="middle" />
                    <TextLinkPopover setElemento={setElemento} selectItem={selectText} />
                    <ImagemPopover
                        onSelect={setSelectedElement}
                        image={imgSelected}
                        code={html}
                        refDiv={refDiv}
                        refreshEditor={refreshEditor}
                    />
                    <TablePopover
                        onSelect={setSelectedElement}
                        code={html}
                        refDiv={refDiv}
                        refreshEditor={refreshEditor}
                        element={templateSelected}
                    />
                    <LayoutPopover
                        onSelect={setSelectedElement}
                        code={html}
                        refDiv={refDiv}
                        refreshEditor={refreshEditor}
                        element={templateSelected}
                    />
                    {textFieldSelected &&
                        <React.Fragment >
                            <Divider orientation="vertical" flexItem sx={{ ml: '0.5' }} variant="middle" />
                            <InpultEditorPopover setElemento={setElemento} textField={textFieldSelected} />
                        </React.Fragment>}
                    <Divider orientation="vertical" flexItem sx={{ ml: '0.5' }} variant="middle" />
                    <TemplatePopover
                        onSelect={setSelectedElement}
                        code={html}
                        refDiv={refDiv}
                        refreshEditor={refreshEditor}
                        element={templateSelected}
                        staticOnly={staticOnly}
                    />
                    { (!staticOnly || staticOnly !== true) && 
                    <WidgetPopover
                        onSelect={setSelectedElement}
                        code={html}
                        refDiv={refDiv}
                        refreshEditor={refreshEditor}
                        element={templateSelected}
                    /> }
                    <FormCompPopover 
                        refDiv={refDiv}
                    />
                    <Divider orientation="vertical" flexItem sx={{ ml: '0.5' }} variant="middle" />
                    { (!staticOnly || staticOnly !== true) && 
                    <Tooltip title="Visão Codigo HTML">
                        <IB
                            onClick={handleSwitchCode}
                            size="small"
                        >
                            <Html />
                        </IB>
                    </Tooltip>
                    }
                    <Tooltip title="Limpar e editar nova pagina">
                        <IB
                            onClick={novaPagina}
                            size="small"
                        >
                            <FiberNew />
                        </IB>
                    </Tooltip>
                    <Box sx={{ flexGrow: 1 }} />
                    {action && action}
                </Stack>

                <div
                    id="very2Editor"
                    // spellCheck="false"
                    ref={refDiv}
                    contentEditable="true"
                    onClick={handleClick}
                    onDoubleClick={handleDbClick}
                    onKeyUp={handleKeyUp}
                    onKeyDown={handleKeyDown}
                    onDragOver={handleDragOver}
                    onDrop={handleOnDrop}
                    onScroll={handleScroll}
                    style={style ? style : {
                        padding: 4, border: '2px solid black', overflow: 'auto', height: '500px'
                    }
                    }
                >
                </div>
                <TableConfigBalloon
                    onSelect={setSelectedElement}
                    code={html}
                    refDiv={refDiv}
                    refreshEditor={refreshEditor}
                    element={selectItem}
                />
            </React.Fragment>
        )
    }
    function HtmlCodeEditor() {
        if (!isHtmlCode) return;

        return (
            <div name="htmlCodeEditor"
                // style={{background: 'yellow', width:'100vh'}}
                style={style ? style : {
                    padding: 4, border: '2px solid black', overflow: 'auto', width:"100%",
                }}
            >
                <Stack direction="row" spacing={0} >
                    <Tooltip title="Formata codigo">
                        <IB
                            variant='container'
                            onClick={handleFormatDocument}
                            size="small"
                        >
                            <Code />
                        </IB>
                    </Tooltip>
                    <Tooltip title={themeEditor === 'vs-dark' ? "Modo claro" : "Modo escuro"}>
                        <IB
                            variant='container'
                            onClick={handleSwitchDarkMode}
                            size="small"
                        >
                            {themeEditor === 'vs-dark' ? <LightMode /> : <DarkMode />}
                        </IB>
                    </Tooltip>
                    <Tooltip title="Modificar constraste">
                        <IB
                            variant='container'
                            onClick={handleSwitchConstraste}
                            size="small"
                        >
                            <Highlight />
                        </IB>
                    </Tooltip>
                    {(!staticOnly || staticOnly !== true) && 
                        <ModeloCodigoPopover code={htmlCode} setCode={setHtmlCode} />
                    }

                    <Divider orientation="vertical" flexItem sx={{ ml: '0.5' }} variant="middle" />
                    <Tooltip title="Visão Editor HTML">
                        <IB
                            variant='container'
                            onClick={handleSwitchCode}
                            size="small"
                        >
                            <Preview />
                        </IB>
                    </Tooltip>

                    <Button onClick={() => {
                        let actions = editorRef.current.getSupportedActions().map((a) => a.id);
                        console.log(actions);
                    }}>
                        Ver todas action
                    </Button>

                    <Box sx={{ flexGrow: 1 }} />
                    {action && action}
                </Stack>
                <Editor
                    height={style ? style.height : "90vh"}
                    // height={"90vh"}
                    width={style? style.width: '100%'}
                    defaultLanguage="html"
                    theme={themeEditor}
                    value={htmlCode}
                    onChange={handleEditorChange}
                    onMount={handleEditorDidMount}
                    options={{
                        minimap: {
                            enabled: false,
                        },
                    }}
                />
            </div>
        )
    }
    return (
        <React.Fragment >
            {HtmlEditor()}
            {HtmlCodeEditor()}
        </React.Fragment>
    )
})

export default VeryEditor2;